import { CalendarMonth } from '@mui/icons-material';
import GlobalSearcher, { Filter } from 'lib/common/GlobalSearcher';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import { formatDateString } from 'lib/functions/utils';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useFundSummaryData } from '../../context/FundSummaryDataContext';
import { useNomineesPeriod } from '../../context/NomineesPeriodContext';

const FundSummaryHeader: React.FC = () => {
  const dispatch = useDispatch();
  const { refetchAll } = useFundSummaryData();
  const {
    startOperationDate,
    endOperationDate,
    setStartOperationDate,
    setEndOperationDate,
  } = useNomineesPeriod();

  const searchFilters: Filter[] = [
    {
      type: 'date',
      label: 'Fecha operación inicio',
      value: startOperationDate,
      setter: setStartOperationDate,
      dateKey: 'startOperationDate',
      pairKey: 'endOperationDate',
    },
    {
      type: 'date',
      label: 'Fecha operación término',
      value: endOperationDate,
      setter: setEndOperationDate,
      dateKey: 'endOperationDate',
      pairKey: 'startOperationDate',
    },
  ];

  const buttons: CustomButtonProps[] = [
    {
      name: 'Buscar',
      color: 'primary',
      action: () => {},
      customButton: (
        <GlobalSearcher
          filters={searchFilters}
          triggerSearch={refetchAll}
          dispatch={dispatch}
          showActionButtons={false}
        />
      ),
    },
  ];

  return (
    <HeaderWithActions
      title={`Resumen: ${formatDateString(startOperationDate, 'dd/mm/yyyy')} - ${formatDateString(endOperationDate, 'dd/mm/yyyy')}`}
      variant="body1"
      buttons={buttons}
      icon={<CalendarMonth color="primary" />}
    />
  );
};

export default FundSummaryHeader;
